import { render, staticRenderFns } from "./EditaFuncionario.vue?vue&type=template&id=160835d0&"
import script from "./EditaFuncionario.vue?vue&type=script&lang=js&"
export * from "./EditaFuncionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports